import FieldStateEnum from '@src/utils/enums/fieldStateEnum';

export default {
  value: null,
  counter: null,
  maxlength: null,
  state: FieldStateEnum.initial,
  showValidation: false,
  max: null,
  min: null,
};
